module.exports = {
        srcSet: __webpack_public_path__ + "amenities_selectshop-50-94cdf5e67139cabc.digested.jpg"+" 50w",
        images: [{path: __webpack_public_path__ + "amenities_selectshop-50-94cdf5e67139cabc.digested.jpg",width: 50,height: 50}],
        src: __webpack_public_path__ + "amenities_selectshop-50-94cdf5e67139cabc.digested.jpg",
        toString: function(){return __webpack_public_path__ + "amenities_selectshop-50-94cdf5e67139cabc.digested.jpg"},
        
        width: 50,
        height: 50
      }